export default "__VITE_ASSET__a613c6fe__"